// / <reference path="../Controller.ts" />
/// <reference path="../../HTML/Navigation/AppInfoItem.ts" />
/// <reference path="./NavigationItem.ts" />
/// <reference path="../../Entity/Menu.ts" />
namespace HA.Core.Controller.Navigation {
    import AppInfoItem = HA.Core.HTML.Navigation.AppInfoItem;

    export class AppInfo extends NavigationItem {
        /**
         * @param data
         */
        public updateInfo(data: Map<any, any>) {
            let tag = this.getTag().findByAttribute("nav-app-name");
            if (tag && data.get("appName")) {
                tag.setText(data.get("appName"));
            }
            tag = this.getTag().findByAttribute("nav-app-title");
            if (tag && data.get("appTitle")) {
                tag.setText(data.get("appTitle"));
            }
            tag = this.getTag().findByAttribute("nav-app-icon");
            if (tag && data.get("appIcon")) {
                tag.setAttribute("src", data.get("appIcon"));
            }
        }

        /**
         *
         * @param quickMenus
         */
        public updateQmenu(quickMenus: Map<any, any>) {
            const app: HA.Core.Entity.Menu = this.get("menuApp");
            if (app) {
                app.clear();
                app.addItem(toMap({
                    id: "main",
                    l: {classes: ["fad", "fa-hand-point-left"], _tn: "i", t: "t"},
                    n: "Revenir",
                    t: "showApp",
                }));
                quickMenus.forEach((qm: any) => {
                    const quickMenu: Map<string, any> = toMap(qm);

                    app.addItem(toMap({
                        id: quickMenu.get("id"),
                        t: quickMenu.get("t"),
                        n: quickMenu.get("n"),
                        l: quickMenu.get("l"),
                    }));
                });
            }

        }

        protected subscribeToAppInfo() {
            const me = this;
            this.getAppManager().subscribe("appInfo", (data: Map<any, any>) => {
                me.updateInfo(data);
            });
            this.getAppManager().subscribe("qmenu", (data: Map<any, any>) => {
                me.updateQmenu(data);
            });
        }

        /**
         *
         * @returns AppManager
         */
        protected getAppManager() {
            return this.getService("ha.service.appManager");
        }

        /**
         * @param data
         */
        protected initialize(data: Map<any, any>) {
            super.initialize(data);
            this.subscribeToAppInfo();
            const app = new HA.Core.Entity.Menu(toMap({
                animation: this.get("animation"),
                services: this.getServiceManager(),
            }));
            app.addItem(toMap({id: "main", t: "showApp", n: "Revenir"}));
            this.addToData("menuApp", app);

            app.setId("app.main.menu");

            getWebPageService().setQMenu(() => { this.click();});
        }

        protected createTag(data: any) {
            this.addToData("tag", new AppInfoItem(data));
        }

        protected click() {
            const timer = setTimeout(() => {
                if (!this.get("preventDClick")) {
                    const app2: HA.Core.Entity.Menu = this.get("menuApp");
                    getWebPageService().toggleApp(toMap({id: app2.getId(), app: app2}));
                }
                this.addToData("preventDClick", false);
            }, 200);

            this.addToData("dclicktimer", timer);

        }

    }
}
